import * as React from "react";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

/**
 * Container component for the Settings page.
 * 
 */
class Settings extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.Settings.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        return (
            <div className="container-fluid body-content">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <h1>Settings</h1>
                    </div>
                </div>
            </div>
        );
    }

}

export default Settings;
